import React from "react";
import "./blockquote.css"

const BlockQuote= (props)=>
{
return(
    <blockquote className="blockquote">
     {props.quote}
    <cite>{props.cite}</cite>
</blockquote>
);
}

export default BlockQuote;